/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 src/components/3d/assets/usa_map.glb -K
Author: Bharad (https://sketchfab.com/Bharad)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/usa-map-low-poly-9048b24fb30c4d4294ac4e46a069667c
Title: USA Map - Low Poly
*/

import React from 'react'
import {useGLTF} from '@react-three/drei'
import {ThreeElements} from "@react-three/fiber";
import assetUrl from './assets/usa_map.glb';
import {Box3, DoubleSide, Group, Mesh, MeshStandardMaterial, Vector3} from "three";


interface StateMeshConfig {
  geometry: string;
  position: number[];
}

const stateCodes = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

// A type generated from the stateCodes array
export type StateCode = typeof stateCodes[number];

export const stateWorldPositions: Record<StateCode, Vector3> = {};

// Use double-sided materials because the normals are incorrect in parts of
// Hawaii and Alaska. If we fix the mesh later we can remove this setting.
const stateMaterials = [
  new MeshStandardMaterial({ color: '#44ff47', side: DoubleSide}),
  new MeshStandardMaterial({ color: '#25bd22', side: DoubleSide}),
  new MeshStandardMaterial({ color: '#167714', side: DoubleSide}),
  new MeshStandardMaterial({ color: '#0d5b0c', side: DoubleSide}),
];

const stateConfig: Record<StateCode, StateMeshConfig> = {
  AR: {
    geometry: 'Arkansas_0',
    position: [0.36, -0.35, 0],
  },
  LA: {
    geometry: 'Louisiana_0',
    position: [0.49, -1.14, 0],
  },
  KY: {
    geometry: 'Kentucky_0',
    position: [1.35, -0.18, 0],
  },
  FL: {
    geometry: 'Florida_0',
    position: [1.73, -1.53, 0],
  },
  PA: {
    geometry: 'Pennsylvania_0',
    position: [2.68, 1.08, 0],
  },
  CT: {
    geometry: 'Connecticut_0',
    position: [3.83, 1.33, 0],
  },
  ND: {
    geometry: 'North_dakota_0',
    position: [-1.08, 2.51, 0],
  },
  ID: {
    geometry: 'Idaho_0',
    position: [-3, 2.8, 0],
  },
  AZ: {
    geometry: 'Arizona_0',
    position: [-3.07, 0.07, 0],
  },
  OR: {
    geometry: 'Oregon_0',
    position: [-4.16, 2.47, 0],
  },
  CO: {
    geometry: 'Colorado_0',
    position: [-2.09, 0.81, 0],
  },
  IA: {
    geometry: 'Iowa_0',
    position: [0.02, 1.24, 0],
  },
  MI: {
    geometry: 'Michigan1_0',
    position: [1, 1.95, 0],
  },
  MI2: {
    geometry: 'Michigan2_0',
    position: [1.66, 0.92, 0],
  },
  NC: {
    geometry: 'North_Carolina_0',
    position: [2.66, -0.15, 0],
  },
  CA: {
    geometry: 'California_0',
    position: [-4.48, 1.57, 0],
  },
  WY: {
    geometry: 'Wyoming_0',
    position: [-2.26, 1.77, 0],
  },
  MN: {
    geometry: 'Minnesota_0',
    position: [-0.05, 2.46, 0],
  },
  IN: {
    geometry: 'indiana_0',
    position: [1.67, 0.91, 0],
  },
  NY: {
    geometry: 'New_york_0',
    position: [2.88, 1.42, 0],
  },
  ME: {
    geometry: 'Maine_0',
    position: [4.03, 2.14, 0],
  },
  VA: {
    geometry: 'Virginia_0',
    position: [2.6, 0.05, 0],
  },
  VT: {
    geometry: 'Vermont_0',
    position: [3.7, 2, 0],
  },
  MS: {
    geometry: 'Mississippi_0',
    position: [1.2, -0.65, 0],
  },
  AL: {
    geometry: 'Alabama_0',
    position: [1.57, -0.63, 0],
  },
  SC: {
    geometry: 'South_Carolina_0',
    position: [2.46, -0.54, 0],
  },
  TX: {
    geometry: 'Texas_0',
    position: [-1.9, -1.27, 0],
  },
  MA: {
    geometry: 'Massachusetts_0',
    position: [3.84, 1.5, 0],
  },
  DE: {
    geometry: 'Delaware_0',
    position: [3.57, 0.73, 0],
  },
  MD: {
    geometry: 'Maryland_0',
    position: [2.94, 0.61, 0.1],
  },
  OH: {
    geometry: 'Ohio_0',
    position: [1.99, 0.91, 0],
  },
  MO: {
    geometry: 'Missouri_0',
    position: [0.18, 0.56, 0],
  },
  WI: {
    geometry: 'Wisconsin_0',
    position: [0.73, 1.97, 0],
  },
  NV: {
    geometry: 'Nevada_0',
    position: [-3.81, 1.38, 0],
  },
  RI: {
    geometry: 'Rhode_island_0',
    position: [4.11, 1.4, 0],
  },
  WV: {
    geometry: 'West_Virginia_0',
    position: [2.77, 0.58, 0],
  },
  TN: {
    geometry: 'Tennessee_0',
    position: [1.3, -0.32, 0],
  },
  NM: {
    geometry: 'New_Mexico_0',
    position: [-2.18, -0.09, 0],
  },
  NE: {
    geometry: 'Nebraska_0',
    position: [-1.18, 1.17, 0],
  },
  MT: {
    geometry: 'Montana_0',
    position: [-2.85, 2.77, 0],
  },
  WA: {
    geometry: 'Washington_0',
    position: [-3.84, 3, 0],
  },
  UT: {
    geometry: 'Utah_0',
    position: [-2.85, 1.16, 0],
  },
  SD: {
    geometry: 'South_Dakota_0',
    position: [-1.13, 1.82, 0],
  },
  OK: {
    geometry: 'Oklahoma_0',
    position: [-1.12, -0.22, 0],
  },
  NH: {
    geometry: 'New_Hampshire_0',
    position: [3.97, 2.07, 0],
  },
  NJ: {
    geometry: 'New_Jersey_0',
    position: [3.66, 1.14, 0],
  },
  GA: {
    geometry: 'Georgia_0',
    position: [2.03, -0.6, 0],
  },
  IL: {
    geometry: 'Illinois_0',
    position: [1.02, 1.02, 0],
  },
  KS: {
    geometry: 'Kansas_0',
    position: [-0.9, 0.46, 0],
  },
  HI: {
    geometry: 'Hawaii_0',
    position: [-1.74, -2.46, 0],
  },
  AK: {
    geometry: 'Alaska_0',
    position: [-3.87, -2.84, 0],
  },
};

// export function latLongToLocalCoordinates(latitude: number, longitude: number): [number, number, number] {
//   const x = longitude * 100;
//   const y = latitude * 100;
//   const z = 0;
//   return [x, y, z];
// }


interface USAProps {
  onStateClick?: (stateCode: StateCode, group: Group) => void;
}

export function USAMap(props: USAProps & ThreeElements['group']) {
  const { nodes, materials } = useGLTF(assetUrl) as any;


  /*
Find: <mesh geometry=\{nodes.(.+)\.geometry\}.*\W+<\/group>
Replace:  XX: {\ngeometry: '$2',\nposition: $1,\n},
  */

  const stateRefs: Record<string, Group> = {};
  const setRef = (stateCode: string) => {
    return (group: Group) => {
      if (group) {
        stateRefs[stateCode] = group;
        if (!stateWorldPositions[stateCode]) {
          const mesh = group.children[0] as Mesh;
          mesh.geometry.computeBoundingBox();
          const box = new Box3();
          box.setFromObject(mesh, true);
          const center = new Vector3();
          box.getCenter(center);
          if (stateCode === "WA") {
            console.log("Calibrate WA max", box.max.clone().add(group.position))
            console.log("Calibrate WA min", box.min.clone().add(group.position))

            // WA min x is -4.17667. IRL min longitude is... -124.73
            // TN max x is 2.65622. IRL max longitude is... -81.66
            // -124.73 * a + b = -4.17667, -81.66 * a + b = 2.65622

            // WA max y is 3, irl is 49.002
            // NC max y is 0.05243, IRL 36.5418
            // 49.002 * a + b = 3, 36.5418 * a + b = 0.05243


          }
          if (stateCode === "TN") {
            console.log("Calibrate TN max", box.max.clone().add(group.position))
            console.log("Calibrate TN min", box.min.clone().add(group.position))
          }
          stateWorldPositions[stateCode] = group.localToWorld(center);
        }
      }
    }
  }

  const dynamicGroups = Object.entries(stateConfig).map(([stateCode, config], index) => {
    return (
      <group
        key={stateCode}
        position={[config.position[0], config.position[1], config.position[2]]}
        ref={setRef(stateCode)}
        onClick={() => {
          if (props.onStateClick) {
            props.onStateClick(stateCode, stateRefs[stateCode]);
          }
        }}
      >
        <mesh geometry={nodes[config.geometry].geometry} material={stateMaterials[index % stateMaterials.length]} />
      </group>
    );
  });

  return (
    <group {...props} dispose={null}>
      <group>
        <group rotation={[-Math.PI / 2, 0, 0]} scale={0.52}>
          <group>
            {dynamicGroups}
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/usa_map.glb')
